import { Product } from '../products/product';
export class CartItem {
    product: Product;
    quantity: number;
    index: number;
}

function CartItem_tsickle_Closure_declarations() {
/** @type {?} */
CartItem.prototype.product;
/** @type {?} */
CartItem.prototype.quantity;
/** @type {?} */
CartItem.prototype.index;
}

